import React, { useState } from "react";
import ReactPlayer from 'react-player'
import iconPLay from "../../../assets/Vector (1).svg";
import { usePlanPermissions } from "../../../hooks/usePlanPermissions";

const ProtectedVideoThumbnail = ({ videoUrl, talentName }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { validateSelfieLetterAccess } = usePlanPermissions();

  const handlePlay = (e) => {
    // Always prevent default first
    e?.preventDefault();
    e?.stopPropagation();

    // Validate access for trial users
    const validation = validateSelfieLetterAccess();
    if (!validation.allowed) {
      return; // Don't start video, modal is already shown
    }

    // If we get here, user has permission
    setIsPlaying(true);
  };

  return (
    <div style={styles.container}>
      {!isPlaying ? (
        <div style={styles.thumbnailContainer} onClick={handlePlay}>
          <div style={styles.aspectWrapper}>
            <ReactPlayer
              url={videoUrl}
              width="100%"
              height="100%"
              playing={false}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                objectFit: "contain",
                borderRadius: "20px",
                background: "#000"
              }}
            />
          </div>
          <div style={styles.playButtonContainer}>
            <img src={iconPLay} alt="Play button" />
          </div>
        </div>
      ) : (
        <div style={styles.aspectWrapper}>
          <video
            controls
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "20px",
              background: "#000",
              position: "absolute",
              top: 0,
              left: 0
            }}
            autoPlay
          >
            <source src={videoUrl} />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    width: "100%",
    borderRadius: "20px",
    overflow: "hidden",
  },
  thumbnailContainer: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
  },
  aspectWrapper: {
    width: "100%",
    aspectRatio: "16/9",
    borderRadius: "20px",
    overflow: "hidden",
    background: "#000",
    position: "relative"
  },
  playButtonContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
    zIndex: 2
  },
  playButton: {
    width: "60px",
    height: "60px",
  },
};

export default ProtectedVideoThumbnail;
